import Introduction from './components/Introduction'

const Home = () => {
    return (
        <div>
            <Introduction/>
        </div>
    )
}

export default Home
